import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a4aeacc&scoped=true&"
import script from "./index.ts?vue&type=script&lang=js&"
export * from "./index.ts?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=6a4aeacc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4aeacc",
  null
  
)

export default component.exports